// 前端操作列表
const FrontendOperation = [
    {
        name: '刷新页面',
        remark: '执行操作后会触发页面的重新加载',
        scene: '页面加载异常或数据需要重置时触发',
    },
    {
        name: '返回上一页',
        remark: '依据页面访问的历史数据，回退到上一次访问的页面；如果上一个页面跳转到当前页面时，设置了不保留历史，则会返回到上上页',
        scene: '当前页面操作完成后，返回到上一页；例如：从列表页面跳转到表单新增数据，表单提交后，返回列表页',
    },
    {
        name: '跳转页面',
        remark: '跳转到指定的系统页面，并支持传递URL参数；自定义的页面支持传递上下文参数给表单页面',
        scene: '需要页面跳转时使用；传递上下文的场景更多是在自定义页面的新增表单和列表行跳转表单详情',
    },
    {
        name: '跳转链接',
        remark: '跳转到任意地址，地址必须时有效URL',
        scene: '新老业务系统对接时使用；例如：某个模块跳转已有业务系统的指定页面',
    },
    {
        name: '提交表单',
        remark: '触发指定表单的提交服务，进行表单数据保存',
        scene: '新增/编辑表单，保存表单数据',
    },
    {
        name: '列表新增行',
        remark: '为当前列表初始化一条空记录',
        scene: '子表单录入场景：为公司客户添加联系人',
    },
    {
        name: '打开弹窗',
        remark: '打开指定的弹窗组件',
        scene: '--',
    },
    {
        name: '关闭弹窗',
        remark: '关闭指定的弹窗组件',
        scene: '--',
    },
    {
        name: '显示/隐藏组件',
        remark: '改变指定组件的显影状态',
        scene: '某个组件的值变化或者被点击后，将另外一个或一组组件进行显示或隐藏',
    },
    {
        name: '列表刷新',
        remark: '刷新指定的列表组件',
        scene: '在组合使用场景下，联动列表的数据源刷新',
    },
    {
        name: '执行函数',
        remark: '执行指定的扩展函数',
        scene: '在平台内置的零代码功能无法满足时，需要编写自定义函数来解决时，可以通过事件配置该动作来执行对应操作',
    },
    // {
    //     name: '变量赋值',
    //     remark: '为页面声明的全局、入参变量赋值',
    //     scene: '页面初始化时为变量赋值；执行某个操作后调整变量值',
    // },
    // {
    //     name: '统计客户价值度',
    //     remark: '用于在客户信息录入后，显示当前新增客户的价值度',
    //     scene: '客户编辑页面',
    // },
]

export {
    FrontendOperation,
}
